import { useApiQuery } from '../useApiQuery';
import { operationsClient, apiGet } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { schedulerKeys } from '@/lib/queryKeys';
import type { ServiceType } from '@/types/scheduler';

/**
 * Fetches the list of service types from the scheduler microservice.
 */
export function useServiceTypes(options: { enabled?: boolean } = {}) {
  return useApiQuery<ServiceType[]>({
    queryKey: schedulerKeys.serviceTypes(),
    queryFn: () => apiGet<ServiceType[]>(operationsClient, schedulerEndpoints.serviceTypes()),
    enabled: options.enabled,
    showErrorToast: false,
  });
}
